import { handleAiAgentSessionsEvent } from "@/helpers/websockets/ai/handlers";

export interface AiAgentSessionsEvent {
  message: string;
  socket: string | null;
}

export const AI_AGENT_SESSIONS_EVENT =
  ".ai_agent_session_response_received" as const;

export const AI_AGENT_SESSIONS_EVENT_HANDLERS = {
  [AI_AGENT_SESSIONS_EVENT]: handleAiAgentSessionsEvent,
};
